// @flow

import * as React from 'react';
import type { NavLinkType } from '@ta/brand.global-nav';
import GlobalNavApiBinding, { NavLinks } from '@ta/brand.global-nav';

type Props = {|
  links: ?(NavLinkType[]),
  activeLinkId: ?string,
  sourceOnly?: boolean,
|};

/** Global nav version of the header navigation (as opposed to T4B for example)
 *  Don't be fooled by the naming (GlobalNavLinks vs GlobalNavLinksV2) and try to clean it up. It is still used in many places (home, profile, etc) */
const GlobalNavLinks = (props: Props) => {
  if (props.links) {
    return (
      <NavLinks
        links={props.links}
        activeLinkId={props.activeLinkId}
        sourceOnly={props.sourceOnly}
      />
    );
  }
  return null;
};

GlobalNavLinks.defaultProps = {
  sourceOnly: false,
};

export default GlobalNavApiBinding(GlobalNavLinks);
